import customizations from '@/api/customizations'

export default {
    namespaced: true,
    state: {
        entityId: null,
        editedItem: {
            primary_color: null,
            dark_theme: null,
            image_url: null,
            infos: null,
            image: null
        },
        primaryColor: null
    },
    actions: {
        fetch ({ state, commit }) {
            return new Promise((resolve, reject) => {
                customizations.index(state.entityId).then(response => {
                    commit('setEditedItem', response.data)
                    resolve(response.data)
                }).catch(error => reject(error));
            })
        },
        saveEditedItem ({ dispatch, state }) {
            return new Promise((resolve, reject) => {
                customizations.store(state.entityId, state.editedItem).then(response => {
                    dispatch('fetch')
                    resolve(response)
                }).catch(error => reject(error))
            })
        },
        deleteItem ({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                customizations.delete(id).then(response => {
                    dispatch('fetch')
                    resolve(response)
                }).catch(error => reject(error))
            })
        }
    },
    mutations: {
        setEditedItem (state, item) {
            const editedItem = {
                primary_color: item.primary_color ?? "#3366ff",
                dark_theme: Object.prototype.hasOwnProperty.call(item, 'dark_theme') ? item.dark_theme : true,
                image_url: item.image_url ?? null,
                infos: item.infos ?? null,
                image: item.image ?? null
            }
            state.editedItem = editedItem
            state.primaryColor = editedItem.primary_color
        },
        setEntityId (state, id) {
            state.entityId = id
        },
        setPrimaryColor (state, value) {
            state.primaryColor = value
            state.editedItem.primary_color = value
        },
        setImage (state, value) {
            state.editedItem.image = value
        },
        setInfos (state, value) {
            state.editedItem.infos = value
        }
    }
}